import React from 'react';
import { Icon } from './Icon.js';
export const IconToggle3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m12.5,4h-5c-3.309,0-6,2.691-6,6s2.691,6,6,6h5c3.309,0,6-2.691,6-6s-2.691-6-6-6Zm-5,10c-2.209,0-4-1.791-4-4s1.791-4,4-4,4,1.791,4,4-1.791,4-4,4Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconToggle3.js.map